<div class="step-container">
  <div class="d-flex d-lg-none justify-content-center">
    <img alt="" src="assets/images/login-registration/registration-logo.svg" class="logo mb-3" />
  </div>
  <h5 class="text-primary text-center text-lg-left">Terms & Conditions</h5>

  <div class="terms font-size-14">
    <fgbcl-terms-and-conditions [type]="termsAndConditionsType.General" [defaultTerms]="loading"></fgbcl-terms-and-conditions>
  </div>

  <div class="mt-2 mt-lg-3 mb-5 mb-lg-4 pb-5 pb-lg-2">
    <div class="accept-box">
      <input type="checkbox" id="accepted" [(ngModel)]="accepted" required />
      <label for="accepted" class="d-inline-block font-size-12 pl-2 font-weight-bold">Accept terms and conditions</label>
      <fgbcl-errors></fgbcl-errors>
    </div>
  </div>

  <div class="button-container position-absolute">
    <fgb-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgb-registration-navigation>
  </div>
</div>

<ng-template #loading>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
